const PlayerPerformanceActionType = {
  CHANGE_TRANSACTION_LOADING_STATE: 'CHANGE_TRANSACTION_LOADING_STATE',

  GET_PLAYERS_AGGREGATIONS: 'GET_PLAYERS_AGGREGATIONS',
  SAVE_PLAYERS_AGGREGATIONS: 'SAVE_PLAYERS_AGGREGATIONS',
  RESET_PLAYERS_AGGREGATIONS: 'RESET_PLAYERS_AGGREGATIONS',
  GENERATE_PLAYERS_AGGREGATIONS_REPORT: 'GENERATE_PLAYERS_AGGREGATIONS_REPORT',
};

export default PlayerPerformanceActionType;
